import { createEffects } from '@angular-architects/ngrx-toolkit';
import { concatMap, from, map } from 'rxjs';
import { companyActions as actions } from './company.action';
import { COMPANY_STORE_INITIAL_STATE } from './company.state';
import { inject } from '@angular/core';
import { ClientService } from '@app/modules/client-management/services/client/client.service';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { AppService } from '../../services/app/app.service';
import { IUserCompanyDetails } from '../../types/user-company-details';

export const companyEffects = createEffects(actions, (actions, create) => {
    const clientService = inject(ClientService);
    const appService = inject(AppService);
    const navigationService = inject(NavigationService);
    return {
        reset$: create(actions.reset).pipe(
            map(() =>
                actions.resetAll({
                    ...COMPANY_STORE_INITIAL_STATE,
                }),
            ),
        ),
        getClientDetailInfo$: create(actions.getClientDetailInfo).pipe(
            map(({ id }) => {
                actions.setIsBusy({ value: true });
                return clientService.getClientById(id).subscribe({
                    next: (res) => {
                        actions.setIsBusy({ value: false });
                        return actions.setClientDetailInfo({
                            value: res,
                        });
                    },
                    error: () => {
                        actions.setIsBusy({ value: false });
                        navigationService.goToNotFoundPage();
                        return from([]);
                    },
                });
            }),
        ),
        getVendorDetailInfo$: create(actions.getVendorDetailInfo).pipe(
            map(({ id }) => {
                actions.setIsBusy({ value: true });
                return clientService.getVendorById(id).subscribe({
                    next: (res) => {
                        actions.setIsBusy({ value: false });
                        return actions.setClientDetailInfo({
                            value: res,
                        });
                    },
                    error: () => {
                        actions.setIsBusy({ value: false });
                        navigationService.goToNotFoundPage();
                        return from([]);
                    },
                });
            }),
        ),
        getClientCompanyLogo$: create(actions.getClientCompanyLogo).pipe(
            map(({ id }) => {
                actions.setIsBusy({ value: true });
                return appService
                    .getUserCompanyDetails(id)
                    .pipe(
                        concatMap((res: IUserCompanyDetails) => {
                            return appService.getCompanyLogo(id, res.companyLogoPath);
                        }),
                    )
                    .subscribe({
                        next: (res) => {
                            actions.setIsBusy({ value: false });
                            return actions.setClientLogo({
                                value: URL.createObjectURL(res),
                            });
                        },
                        error: () => {
                            return from('');
                        },
                    });
            }),
        ),
    };
});
